export const ClaimingAgentMenuIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    fill={'none'}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.6665 8.33333L9.99984 11.6667L13.3332 8.33333M3.33317 2.5H16.6665C17.1085 2.5 17.5325 2.67559 17.845 2.98816C18.1576 3.30072 18.3332 3.72464 18.3332 4.16667V9.16667C18.3332 11.3768 17.4552 13.4964 15.8924 15.0592C14.3296 16.622 12.21 17.5 9.99984 17.5C8.90549 17.5 7.82186 17.2845 6.81081 16.8657C5.79976 16.4469 4.8811 15.833 4.10728 15.0592C2.54448 13.4964 1.6665 11.3768 1.6665 9.16667V4.16667C1.6665 3.72464 1.8421 3.30072 2.15466 2.98816C2.46722 2.67559 2.89114 2.5 3.33317 2.5Z"
      stroke={props?.color || '#101828'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
